<template>
    <div>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow"
                    :gutter="16">
                    <Col span="24">
                    <search-card :form="mainTable.searchForm"
                        :table-load-event="getMainTableRecords"
                        :table-search="mainTable.tableSearch" />
                    </Col>
                </Row>
            </transition>

            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">备用仓明细</span>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                        <Button type="success"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="onEntry">备用库入库单</Button>
                        <Button type="info"
                            size='small'
                            class="btns"
                            shape="circle"
                            @click="onExport()">导出</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="storeList"
                    :loading="mainTable.tableLoading"
                    :extHeight="60"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>
        <WarehouseForwardEntryList ref="warehouseForwardEntryListModal" />
    </div>
</template>

<script>
import { currencyRender, dateRender } from '@/libs/tableRowTimeRender';
import CurrencyInput from '@/components/number-input/currency-input';
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import WarehouseForwardEntryList from './../../preSale-management/preSale-warehouse-forward-entry/preSale-warehouse-forward-entry-list';
import { getWarehouseForwardProductStore } from '@/api/modules/warehouse-management/warehouse';
import { DOWNLOAD_SERVER } from '@/api/modules/files';

export default {
    name: 'ForwardWarehouseStore',
    components: {
        CurrencyInput,
        StandPaginationTable,
        SearchCard,
        WarehouseForwardEntryList
    },
    data() {
        return {
            mainTable: {
                columns: [
                    { title: '仓库', key: 'warehouseName', align: 'center', excel: true },
                    { title: '产品编号', key: 'productCode', align: 'center', excel: true },
                    { title: '产品名称', key: 'productName', align: 'center', excel: true },
                    { title: '小类', key: 'subCategoryName', align: 'center', excel: true },
                    { title: '批次号', key: 'warehouseForwardProductStoreBatchCode', align: 'center', excel: true },
                    { title: '仓存量', key: 'warehouseForwardProductStoreAmount', align: 'center', excel: true },
                    { title: '销售期限', key: 'warehouseForwardProductStoreSalePeriod', align: 'center', excel: true },
                    { title: '过鲜日期', key: 'warehouseForwardProductStoreExpiredDate', align: 'center', excel: true, render: (h, params) => dateRender(h, params.row.warehouseForwardProductStoreExpiredDate) },
                    { title: '入库价', key: 'warehouseForwardProductStoreBatchPrice', align: 'center', excel: true, render: (h, params) => currencyRender(h, params.row.warehouseForwardProductStoreBatchPrice) }
                ],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '产品信息', type: 'Input', value: '', name: 'concat(productCode,productName)', sql: 'like' },
                    { label: '批次号', type: 'Input', value: '', name: 'warehouseForwardProductStoreBatchCode', sql: 'like' },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' }
                ]
            },
            storeList: []
        };
    },
    mounted() {
        this.getMainTableRecords();
    },
    methods: {
        onEntry() {
            this.$refs.warehouseForwardEntryListModal.showModal();
        },
        onExport() {
            const searchCondition = search.deepClone(this.mainTable.tableSearch);
            searchCondition.limit.enable = false;
            searchCondition.excelExport.enable = true;
            searchCondition.excelExport.columns = this.mainTable.columns
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.title
                    };
                });

            this.mainTable.tableLoading = true;
            getWarehouseForwardProductStore(searchCondition).then(res => {
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    let url = DOWNLOAD_SERVER + res.data.exportFileName;
                    this.$downLoadFile(url);
                    // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                }
            });
        },
        getMainTableRecords(reset = false) {
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableLoading = true;
            getWarehouseForwardProductStore(this.mainTable.tableSearch).then(res => {
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    this.storeList = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
            }).catch(() => {
                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
